const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const isIOS = /iPad|iPhone|iPod/i.test(ua);

export const msalConfig = {
  auth: {
    clientId: "2364512a-531e-49d1-a7a7-a56814bf19f1",
    authority: "https://login.microsoftonline.com/common/",
    redirectUri: `${window.location.origin}/auth/microsoft/callback`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIOS, // ✅ helps iOS browsers
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
